export default __webpack_public_path__ + "static/media/calendar.4abc637f.svg";